import moment from "moment";
export const getCurrentDate = () => {
  const currentDate = moment(new Date()).format("DD MMM YYYY - hh:mm:ss A");
  return currentDate;
};
export const toAbsoluteUrl = (pathname) => process.env.PUBLIC_URL + pathname;
